// Module
var code = "<span title=\"{{row.eid}}\" ng-class=\"[row.term.class + '-text']\">{{row.eid}}</span>";
// Exports
module.exports = code;